// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/services/relatoriosEstoqueService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  EstoqueAnaliticoItem,
  EstoqueGiroItem,
  PaginadoResponse,
} from '../types';

const BASE = '/api/estoque/relatorios';

export const relatoriosEstoqueService = {
  async getAnalitico(params: {
    produtoId?: number;
    localId?: number;
    tipoId?: number;
    dtInicio?: string;
    dtFim?: string;
    pagina?: number;
    tamanhoPagina?: number;
  }): Promise<PaginadoResponse<EstoqueAnaliticoItem>> {
    const { data } = await apiClient.get<PaginadoResponse<EstoqueAnaliticoItem>>(
      `${BASE}/analitico`,
      { params },
    );
    return data;
  },

  async getGiro(params: {
    dtInicio?: string;
    dtFim?: string;
    localId?: number;
  }): Promise<EstoqueGiroItem[]> {
    const { data } = await apiClient.get<EstoqueGiroItem[]>(`${BASE}/giro`, { params });
    return data;
  },
};
